export const getApp = () => {
    try {
        const href = window.location.href;
        const url = href.substring(href.indexOf("/#/") + 3); // Extract part after /#/
        const segments = url.split("/"); // Split by /
        const currentApplication = segments[0]; // Get the first segment
        return currentApplication || "celine"; // Return 'HomePage' if empty
    }
    catch (error) {
        console.error("Error extracting current application:", error);
        return "celine"; // Return 'HomePage' in case of an error
    }
};
/**
 * Retrieves the current page path from the window's location hash.
 *
 * @returns {string} The current page path as a string. If an error occurs, returns 'Unknown'.
 */
export const getPagePath = () => {
    try {
        const url = new URL(window.location.href);
        return url.hash.substring(1); //
        // return 'hello';
        // return (window.location.hash === '#/') ? 'HomePage' : window.location.pathname;
        // return window.location.pathname :;
        // return window.location.hash;
    }
    catch (error) {
        console.error("Error extracting pathname application:", error);
        return "Unknown";
    }
};
export const getApplication = () => {
    const href = window.location.href;
    const url = href.substring(href.indexOf("/#/") + 3); // Extract part after /#/
    const segments = url.split("/"); // Split by /
    const currentApplication = segments[0]; // Get the first segment
    return currentApplication || "celine"; // Return 'HomePage' if empty
};
/**
 * Retrieves the title of the current document.
 *
 * @returns {string} The title of the document. If an error occurs, returns 'Unknown'.
 */
export const getPageTitle = () => {
    try {
        return document.title;
    }
    catch (error) {
        console.error("Error extracting title application:", error);
        return "Unknown";
    }
};
/**
 * Retrieves the current page's URL.
 *
 * @returns {string} The URL of the current page. If an error occurs, returns 'Unknown'.
 *
 * @throws Will log an error to the console if there is an issue accessing the window location.
 */
export const getPageLocation = () => {
    try {
        return window.location.href;
    }
    catch (error) {
        console.error("Error extracting href application:", error);
        return "Unknown";
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/utils/url.js
// module id = ./node_modules/@celine/passive-tracking/dist/utils/url.js
// module chunks = 0